import { ShieldCheck, BadgeCheck, Phone, Star } from "lucide-react";

const ICONS = [
  { icon: ShieldCheck, title: "25 lat gwarancji", desc: "na panele" },
  { icon: BadgeCheck, title: "Sprawdzony instalator", desc: "weryfikujemy partnerów" },
  { icon: Phone, title: "Szybki kontakt", desc: "5–10 min od pozostawienia numeru" },
];

export default function MicroProofMontaz() {
  return (
    <section
      className="py-12 lg:py-16 bg-white"
      data-testid="micro-proof-section-montaz"
      aria-label="Zaufanie i opinia"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-5">
          {ICONS.map(({ icon: Icon, title, desc }) => (
            <div
              key={title}
              className="flex items-center gap-3 sm:gap-4 bg-brand-surface rounded-2xl p-4 sm:p-5 border border-brand-blue/10"
              data-testid={`microproof-montaz-${title.replace(/\s+/g, "-").toLowerCase()}`}
            >
              <div className="grid place-items-center h-11 w-11 rounded-full bg-white text-brand-blue flex-shrink-0 shadow-sm">
                <Icon className="h-5 w-5" strokeWidth={1.8} />
              </div>
              <div>
                <p className="font-heading font-bold text-brand-ink leading-tight">{title}</p>
                <p className="text-sm text-brand-muted mt-0.5">{desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Mini review */}
        <div className="mt-8 max-w-3xl mx-auto text-center" data-testid="mini-review-montaz">
          <div className="flex items-center justify-center gap-1">
            {[0, 1, 2, 3, 4].map((i) => (
              <Star key={i} className="h-5 w-5 fill-brand-yellow text-brand-yellow" />
            ))}
          </div>
          <p className="mt-3 font-heading text-lg sm:text-xl text-brand-ink leading-snug">
            “Oddzwonili szybko, wszystko jasno wyjaśnione i bez nacisku.”
          </p>
          <p className="mt-2 text-sm text-brand-muted">
            — Paweł, Mazowieckie · 4,9/5 średnia ocena
          </p>
        </div>
      </div>
    </section>
  );
}
